import React, { useState, useEffect } from 'react';

import ProfileNotesLogsCall from '../Components/ProfileNotesLogsCall';
import { INTEGRATION_TYPE } from '../Constants/Integrations';

export default function ProfileNotesLogsCalls({ userId, indId, userAccessToken, onSetupClick }) {
  const [calls, setCalls] = useState(null);
  const [callsPage, setCallsPage] = useState(null);
  const [callsPages, setCallsPages] = useState([]);
  const [callsLimit] = useState(10);
  const [callsOffset, setCallsOffset] = useState(0);
  const [callsLoading, setCallsLoading] = useState(true);

  var webAPI = new MedicareProAPI.WebAPI();
  webAPI.setAccessToken(userAccessToken);

  var userCallLogRepository = new MedicareProAPI.UserCallLogRepository();
  userCallLogRepository.setAccessToken(userAccessToken);

  const handleChangePage = (newPage) => {
    setCallsPage(newPage);
    setCallsOffset((newPage - 1) * callsLimit);
  };

  useEffect(() => {
    setCallsLoading(true);

    userCallLogRepository
      .getUserIndCallLogs(userId, indId, {
        limit: callsLimit,
        offset: callsOffset,
        include: ['summaries'],
      })
      .then((response) => {
        setCallsLoading(false);
        setCalls(response.getItems());

        let totalPages = Math.ceil(response.getTotal() / callsLimit);
        let pages = [];

        while (totalPages > 0) {
          pages.push({
            label: totalPages,
            value: totalPages,
          });

          totalPages--;
        }

        pages.reverse();

        setCallsPages(pages);
      });
  }, [callsOffset]);

  return (
    <>
      <div className="row call-log pt-2">
        {callsLoading && (
          <div className="col-12">
            <div className="alert small alert-info" role="alert">
              <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
            </div>
          </div>
        )}
        {callsLoading === false && calls && calls.length > 0 && (
          <>
            {calls.map((call, callIndex) => {
              let data = call.render();
              return (
                <ProfileNotesLogsCall
                  call={call}
                  data={data}
                  userAccessToken={userAccessToken}
                  userId={userId}
                  indId={indId}
                />
              );
            })}

            {callsPages && callsPages.length > 1 && (
              <div className="col-12 mt-1">
                <span class="small d-inline-block mr-1">Page:</span>
                <select
                  onChange={(e) => handleChangePage(parseInt(e.target.value))}
                  className="form-control-sm border-secondary d-inline-block"
                >
                  {callsPages.map((callsPageSingle) => {
                    return (
                      <option
                        selected={callsPageSingle.value === callsPage}
                        value={callsPageSingle.value}
                      >
                        {callsPageSingle.label}
                      </option>
                    );
                  })}
                </select>
                <span class="small d-inline-block ml-1">of {callsPages.length}</span>
              </div>
            )}
          </>
        )}
        {calls && calls.length === 0 && (
          <div className="col-12">
            <div>
              <i className="far fa-exclamation-circle"></i> No call logs
            </div>

            <div
              className="badge badge-pill badge-info cp mt-2"
              style={{ fontSize: '8pt' }}
              onClick={() => onSetupClick(INTEGRATION_TYPE.VOIP_CALL)}
            >
              <i className="far fa-plus-circle"></i> Add/Edit an integration
            </div>
          </div>
        )}
      </div>
    </>
  );
}
